/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MostRelevantServiceProviderRequest
 */
export interface MostRelevantServiceProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof MostRelevantServiceProviderRequest
     */
    clientOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof MostRelevantServiceProviderRequest
     */
    serviceType: string;
    /**
     * 
     * @type {string}
     * @memberof MostRelevantServiceProviderRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the MostRelevantServiceProviderRequest interface.
 */
export function instanceOfMostRelevantServiceProviderRequest(value: object): boolean {
    if (!('clientOrgId' in value)) return false;
    if (!('serviceType' in value)) return false;
    if (!('userId' in value)) return false;
    return true;
}

export function MostRelevantServiceProviderRequestFromJSON(json: any): MostRelevantServiceProviderRequest {
    return MostRelevantServiceProviderRequestFromJSONTyped(json, false);
}

export function MostRelevantServiceProviderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MostRelevantServiceProviderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientOrgId': json['clientOrgId'],
        'serviceType': json['serviceType'],
        'userId': json['userId'],
    };
}

export function MostRelevantServiceProviderRequestToJSON(value?: MostRelevantServiceProviderRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientOrgId': value['clientOrgId'],
        'serviceType': value['serviceType'],
        'userId': value['userId'],
    };
}

